import { motion } from "framer-motion";

const AiDrivenInsights = () => {
  return (
    <section className="relative w-full py-4 sm:py-6 md:py-8 lg:py-10 xl:py-12 px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 overflow-hidden bg-white">
      {/* Container for alignment */}
      <motion.div
        className="w-full mx-auto relative z-10"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: "easeOut" }}
      >
        {/* Top Header Row */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-start gap-4 sm:gap-6">
          {/* Main Title Part 1 */}
          <motion.h2
            className="text-[30px] md:text-[45px] lg:text-[65px] leading-tight font-semibold text-brandDark tracking-tight font-jakarta"
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
          >
           Technology
          </motion.h2>

          {/* Description Text */}
          <motion.div
            className="max-w-[380px] md:mt-4 flex justify-end items-end"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            <p className="text-brandDark text-sm sm:text-base lg:text-lg leading-relaxed font-medium md:w-[95%] lg:w-[85%]">
              Enhancing visibility through integration of supply chain products
              for optimized operations & decision-making.
            </p>
          </motion.div>
        </div>

        {/* Bottom Header Row */}
        <motion.div
          className="flex justify-start md:justify-center lg:justify-start md:ml-20 lg:ml-64"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.5 }}
        >
          {/* Main Title Part 2 with Custom Gradient */}
          <h2 className="text-[30px] md:text-[45px] lg:text-[75px] leading-tight font-semibold tracking-tight font-instrument">
            <motion.span
              className="bg-gradient-to-r from-brandOrange via-brandDark via-[48%] to-brandCyan bg-clip-text text-transparent"
              initial={{ opacity: 0, scale: 0.92 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, delay: 0.7, ease: "easeOut" }}
            >
              AI-Driven Insights
            </motion.span>
          </h2>
        </motion.div>
      </motion.div>

      {/* Decorative Blur Blob */}
      <motion.div
        className="absolute top-[20%] -right-20 w-[300px] h-[350px] pointer-events-none opacity-40 blur-[80px]"
        initial={{ opacity: 0, scale: 0.6, x: 80 }}
        whileInView={{ opacity: 0.4, scale: 1, x: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.4, delay: 0.4, ease: "easeOut" }}
      >
        <div className="w-full h-full bg-gradient-to-br from-blue-300 via-purple-300 to-pink-300 rounded-full animate-pulse" />
      </motion.div>
    </section>
  );
};

export default AiDrivenInsights;
